var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2631 3649)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_483",
    "data-name": "Ret\\xE2ngulo 483",
    width: 80.047,
    height: 46.694,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_CAN",
    transform: "translate(-2631 -3649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_canada",
    transform: "translate(2621.431 3655.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_480",
    "data-name": "Ret\\xE2ngulo 480",
    width: 18.831,
    height: 73.506,
    transform: "translate(0 -13.406)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_481",
    "data-name": "Ret\\xE2ngulo 481",
    width: 18.831,
    height: 73.506,
    transform: "translate(61.217 -13.406)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_482",
    "data-name": "Ret\\xE2ngulo 482",
    width: 42.386,
    height: 73.506,
    transform: "translate(18.831 -13.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_806",
    "data-name": "Grupo 806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_805",
    "data-name": "Grupo 805",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7062",
    "data-name": "Caminho 7062",
    d: "M715.627,4.536,712.849,9.93c-.315.587-.878.527-1.444.2l-2.014-1.088,1.5,8.292c.318,1.516-.7,1.516-1.194.862l-3.508-4.093-.57,2.075a.675.675,0,0,1-.787.491L700.4,15.7l1.164,4.414c.253.985.443,1.393-.251,1.651l-1.581.774L707.368,29a1.057,1.057,0,0,1,.342,1.081l-.666,2.287c2.627-.314,4.989-.6,7.611-.919.234,0,.625.207.622.487l-.35,8.371h1.281l-.2-8.352c0-.274.354-.506.582-.506,2.633.316,4.989.606,7.619.919l-.674-2.287a1.082,1.082,0,0,1,.35-1.081l7.637-6.462-1.581-.774c-.7-.258-.5-.666-.251-1.651l1.166-4.414-4.437.975a.676.676,0,0,1-.787-.491l-.568-2.075L721.55,18.2c-.5.654-1.509.654-1.193-.862l1.5-8.292-2.006,1.088c-.568.324-1.134.384-1.444-.2Z",
    transform: "translate(-675.603 1.517)",
    fill: "#ea0020"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCan);
export default __webpack_public_path__ + "static/media/flag_CAN.c955afcd4a1e7647d32d32a5d2faecff.svg";
export { ForwardRef as ReactComponent };